module.exports = __webpack_public_path__ + "img/recruitment.653a12dc.svg";